import React from 'react';
import PropTypes from 'prop-types';
import PrimaryNavBar from 'commonComponents/PrimaryNavBar';
import PrimaryNavBarOld from 'commonComponents/PrimaryNavBarOld';

/**
 * EmptyStateSideBar Component - renders a minimal sidebar when there's an error state
 * (e.g., user profile error) where normal sidebar data isn't available
 */
const EmptyStateSideBar = ({
  showNewUI,
  shouldSidebarRender,
  shouldHeaderRender,
  userProfileError,
  userDetails,
}) => {
  const emptyStateSidebarProps = {
    apps: [],
    userDetails: userDetails || { firstName: '', lastName: '', title: '' },
    handleNavChange: () => {},
    defaultAppId: '',
    msgsCount: 0,
    show: shouldSidebarRender,
    shouldHeaderRender,
    userProfileError,
  };

  return (
    showNewUI
      ? <PrimaryNavBar {...emptyStateSidebarProps} />
      : <PrimaryNavBarOld {...emptyStateSidebarProps} />
  );
};

EmptyStateSideBar.propTypes = {
  /**
   * Whether to show the new UI or old UI
   */
  showNewUI: PropTypes.bool.isRequired,

  /**
   * Whether the sidebar should be rendered
   */
  shouldSidebarRender: PropTypes.bool,

  /**
   * Whether the header should be rendered
   */
  shouldHeaderRender: PropTypes.bool,

  /**
   * Whether there's a user profile error
   */
  userProfileError: PropTypes.bool,

  /**
   * User details from Redux; when provided the avatar shows real data instead of blanks. #genai
   */
  userDetails: PropTypes.shape(),
};

EmptyStateSideBar.defaultProps = {
  shouldSidebarRender: true,
  shouldHeaderRender: true,
  userProfileError: false,
  userDetails: null,
};

export default EmptyStateSideBar;
